/* eslint-disable react/prop-types */
import { Breadcrumbs, Typography } from "@mui/material";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import MessageBar from "../components/SnackBar/MessageBar";
import { useDispatch, useSelector } from "react-redux";
import { updateNextPath } from "../_redux/SelectedNextPath";
import GetJobId from "../_utilities/GetJobId";

import { getRequiredMenu } from "./layoutdata";

import { clearAuth } from "../_redux/AuthSlice";
import { getUserDetails } from "../_utilities/getUserInfo";
import { authService } from "../api/authApi";
import Header from "./Header";
import NavSidebar from "./NavSidebar";
import Footercomp from "../components/Footercomp";
import Cookies from "js-cookie";
import Mark from "mark.js";
import { ApplicantsById } from "../_redux/_apiHelpers/ApplicantsApihelper";
import { GetClients } from "../_redux/_apiHelpers/ClientsApihelper";
import { Jobpostingsbyid } from "../_redux/_apiHelpers/JobPostingApihelper";
import { GetProjectById } from "../_redux/_apiHelpers/ProjectsApihelper";
import { resetHighlightFilter } from "../_redux/HighlightSlice";
import { setBreadCrumb } from "../_utilities/breadCrumb";
import { GetTimeZone, getWorkonDate } from "../_utilities/GetTimeZone";
import { IconsComponent } from "../Icons/IconsComponent";
import { persistor, resetStore } from "../store";
import { resetSelectedApplicant } from "../_redux/SelectedApplicantSlice";
import moment from "moment-timezone";
import { truncateWords } from "../_utilities/utilities";
import { jobpostingsbyidStartReducer } from "../_redux/_services/JobPostingSlice";
import { resetSelectedJobPosting } from "../_redux/SelectedJobPostingSlice";
import { toggleSidebar } from "../_redux/Uislice";

const drawerWidth = 260;

function Layout() {
  const [menuData, setMenuData] = useState(null);
  const [menuType, setMenuType] = useState(null);
  const [breadcrumbChild, setBreadcrumbChild] = useState([]);
  const [islandingPage, setIslandingPage] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const showLoader = useSelector((state) => state.Loader);
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);
  const showMessage = useSelector((state) => state.Snackbar.message);
  const showMsgType = useSelector((state) => state.Snackbar.type);
  const nextPathValue = useSelector((state) => state.SeletedNextPath.value);
  const [subPathName, setSubPathName] = useState("");
  const { themeSettings } = useSelector((state) => state.theme);
  const outletRefreshKey = useSelector((state) => state.ui.outletRefreshKey);
  const isSidebarHidden = useSelector((state) => state.ui.isSidebarHidden);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const getJobCode = GetJobId();
  const [isAssociated, setIsAssociated] = useState("");

  const [BreadCrumbData, setBreadCrumbData] = useState([]);
  const [BreadCrumbObj, setBreadCrumbObj] = useState([]);
  const [applicantsMenus, setapplicantsMenus] = useState([]);
  const [clientsMenus, setclientsMenus] = useState([]);
  const [customerMenus, setcustomerMenus] = useState([]);
  const [managerMenus, setmanagerMenus] = useState([]);
  const [helpSectionMenus, sethelpSectionMenus] = useState([]);
  const [jobPostingMenus, setjobPostingMenus] = useState([]);
  const [projectsMenus, setprojectsMenus] = useState([]);
  const { advSearchObj } = useSelector((state) => state.Highlight);

  useEffect(() => {
    setBreadCrumbData(getRequiredMenu("BreadCrumbData", themeSettings));
    setBreadCrumbObj(getRequiredMenu("BreadCrumbObj", themeSettings));
    setapplicantsMenus(getRequiredMenu("applicantsMenus", themeSettings));
    setclientsMenus(getRequiredMenu("clientsMenus", themeSettings));
    setcustomerMenus(getRequiredMenu("customerMenus", themeSettings));
    setmanagerMenus(getRequiredMenu("managerMenus", themeSettings));
    sethelpSectionMenus(getRequiredMenu("helpSectionMenus", themeSettings));
    setjobPostingMenus(getRequiredMenu("jobPostingMenus", themeSettings));
    setprojectsMenus(getRequiredMenu("projectsMenus", themeSettings));
  }, []);

  useEffect(() => {
    if (
      nextPathValue !== "" &&
      nextPathValue !== "null" &&
      breadcrumbChild.length > 0
    ) {
      let rawData = JSON.parse(JSON.stringify(breadcrumbChild));
      let subpath = {
        id: 5,
        name: nextPathValue,
        icon: "Clients", // `${process.env.PUBLIC_URL}/assests/img/personicon.svg`
        type: "",
      };
      if (rawData[rawData.length - 1].id === 5) {
        if (rawData[rawData.length - 1].name === nextPathValue) return;
        rawData[rawData.length - 1] = subpath;
      } else {
        rawData.push(subpath);
      }
      setBreadcrumbChild(rawData);
    }
    if (nextPathValue === "null") {
      let rawData = JSON.parse(JSON.stringify(breadcrumbChild));
      if (rawData && rawData.length > 0) {
        if (rawData[0]?.name === "Job Postings") {
          setMenuData(jobPostingMenus);
          setMenuType("jobpostings");
          navigate(`${jobPostingMenus[2].url}/${isAssociated}`);
        } else if (rawData[0]?.name === "Applicants") {
          setMenuData(applicantsMenus);
          setMenuType("applicants");
          navigate(`${applicantsMenus[2].url}/${isAssociated}`);
        }
        if (rawData.length > 3) {
          rawData.length = 3;
          setBreadcrumbChild(rawData);
        }
        sessionStorage.removeItem("AssociatedId");
        setIsAssociated("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextPathValue, breadcrumbChild]);

  useEffect(() => {
    if (outletRefreshKey !== 0) {
      MenuChangeHandler();
    }
  }, [outletRefreshKey]);

  useEffect(() => {
    if (jobPostingMenus.length > 0) {
      MenuChangeHandler();
      const url = window.location.pathname;
      const path = url.substring(url.lastIndexOf("/") + 1);
      if (
        path === "landing" ||
        path === "layout" ||
        path === "jobdetails" ||
        path === "dashboard"
      ) {
        sessionStorage.removeItem("AssociatedId");
        sessionStorage.removeItem("actualId");
        setIsAssociated("");
        setMenuType("");
        setMenuData(null);
        setBreadcrumbChild([]);
        dispatch(toggleSidebar(false));
      }
    }
    // eslint-disable-next-line
  }, [
    location,
    getJobCode,
    BreadCrumbData,
    BreadCrumbObj,
    applicantsMenus,
    clientsMenus,
    customerMenus,
    managerMenus,
    helpSectionMenus,
    jobPostingMenus,
  ]);

  useEffect(() => {
    sessionStorage.removeItem("AssociatedId");
  }, []);

  const MenuChangeHandler = async () => {
    const url = window.location.pathname;
    const path = url.substring(url.lastIndexOf("/") + 1);
    const isJobposting = url.includes("jobpostings");
    const isApplicants = url.includes("applicants");
    const isClients = url.includes("clients");
    const isHelpSection = url.includes("helpsection");
    const isCustomer = url.includes("customer");
    const isProjects = url.includes("projects");
    let comparePath = removelastSlash(url);
    if (isAssociated !== "") {
      let updateBreadcrumb = JSON.parse(JSON.stringify(breadcrumbChild));
      let pathName = comparePath.substring(comparePath.lastIndexOf("/") + 1);

      let index = updateBreadcrumb.findIndex(
        (x) => x.name === "Associated Jobs",
      );
      if (pathName !== "jobview" && index === -1) {
        updateBreadcrumb[4] = {
          id: 0,
          name:
            pathName === "associatedJobs" && pathName === "associatedapplicants"
              ? "View"
              : pathName,
          url: `#`,
          icon: `${process.env.PUBLIC_URL}/assests/img/personicon.svg`,
          type: "",
        };
      }
      setBreadcrumbChild(updateBreadcrumb);
    } else {
      if (
        path !== "landing" &&
        path !== "dashboard" &&
        path !== "create" &&
        path !== "jobdetails" &&
        path !== "document" &&
        path !== "questions" &&
        path !== "portals" &&
        path !== "recommendedTalent" &&
        isJobposting
      ) {
        setMenuData(jobPostingMenus);
        setMenuType("jobpostings");
        const postingSubpathData = await generateSubpath(
          "jobpostings",
          comparePath,
          path,
          "Job Code",
        );
        setBreadcrumbChild(postingSubpathData);
      } else if (
        path !== "landing" &&
        path !== "dashboard" &&
        path !== "create" &&
        path !== "create-duplicate" &&
        path !== "create-new" &&
        path !== "create-new-duplicate" &&
        path !== "create-bulk" &&
        isApplicants
      ) {
        setMenuData(applicantsMenus);
        setMenuType("applicants");
        const applicantSubpathData = await generateSubpath(
          "applicants",
          comparePath,
          path,
          "Applicant Code",
        );
        setBreadcrumbChild(applicantSubpathData);
      } else if (
        path !== "landing" &&
        path !== "dashboard" &&
        path !== "create" &&
        isClients
      ) {
        setMenuData(clientsMenus);
        setMenuType("clients");
        const clientsSubpathData = await generateSubpath(
          "clients",
          comparePath,
          path,
          "clients",
        );
        setBreadcrumbChild(clientsSubpathData);
      } else if (
        path !== "landing" &&
        path !== "dashboard" &&
        path !== "create" &&
        isHelpSection
      ) {
        setMenuType("helpsection");
        setMenuData(helpSectionMenus);
        setBreadcrumbChild([]);
      } else if (
        path !== "landing" &&
        path !== "dashboard" &&
        path !== "create" &&
        isCustomer
      ) {
        setMenuType("customer");
        let subpathObj = await getUserDetails();
        let portalData = JSON.parse(subpathObj.portals)[0].portal;
        let modifyMenuList = customerMenus;

        if (subpathObj.systemroles === "Admin") {
          if (!portalData.includes("2")) {
            let vendorIndex = modifyMenuList.findIndex(
              (x) => x.menuName === "Vendors",
            );
            if (vendorIndex !== -1) {
              modifyMenuList.splice(vendorIndex, 1);
            }
          }
          setMenuData(modifyMenuList);
        } else if (subpathObj.systemroles === "Manager") {
          setMenuData(managerMenus);
        }
        let path = url.replace("/ats/layout/", "");
        let filteredData1 = BreadCrumbData.filter(
          (x) => x.url === path && x.type === "customer",
        );
        if (filteredData1.length > 0) {
          let dataArray = [];

          if (subpathObj) {
            let subpath = {
              id: subpathObj.id,
              name: subpathObj.companyName,
              icon: "",
              type: "",
            };
            dataArray.push(subpath);
          }
          let ArryObj = JSON.parse(JSON.stringify(filteredData1[0]));
          ArryObj.url = undefined;
          dataArray.push(ArryObj);
          setBreadcrumbChild(dataArray);
        }
      } else if (
        path !== "landing" &&
        path !== "dashboard" &&
        path !== "create" &&
        isProjects
      ) {
        setMenuData(projectsMenus);
        setMenuType("projects");
        const projectsSubpathData = await generateSubpath(
          "projects",
          comparePath,
          path,
          "projects",
        );
        setBreadcrumbChild(projectsSubpathData);
      } else if (path === "" || path === "layout") {
        const userInfo = await getUserDetails();
        if (userInfo?.systemroles === "Field Recruiter") {
          navigate("/ats/layout/applicants/list/landing");
        } else {
          navigate("/ats/layout/jobpostings/landing");
        }
      } else {
        setMenuType("");
        setMenuData(null);
        setBreadcrumbChild([]);
      }
    }
    setIslandingPage(
      path === "landing" ||
        path === "create" ||
        path === "jobdetails" ||
        path === "document" ||
        path === "questions" ||
        path === "portals"
        ? true
        : false,
    );
  };

  const removelastSlash = (str) => {
    let path = str.replace("/ats/layout/", "");
    return path.slice(0, path.lastIndexOf("/"));
  };

  const generateSubpath = async (
    BreadCrumbType,
    comparePath,
    path,
    subpathType,
  ) => {
    let filteredData = BreadCrumbData.filter(
      (x) => x.url === comparePath && x.type === BreadCrumbType,
    );
    if (filteredData.length > 0) {
      let dataArray = [],
        subpathUrl = "";
      if (filteredData[0].url.includes("jobpostings")) {
        dataArray.push(BreadCrumbObj[0]);
        subpathUrl = "jobpostings/view/";
      } else if (filteredData[0].url.includes("applicants")) {
        dataArray.push(BreadCrumbObj[1]);
        subpathUrl = "applicants/view/";
      } else if (filteredData[0].url.includes("projects")) {
        dataArray.push(BreadCrumbObj[5]);
        subpathUrl = "projects/view/";
      } else {
        dataArray.push(BreadCrumbObj[2]);
        subpathUrl = "clients/view/";
      }
      if (Number.isInteger(parseInt(path))) {
        let subpathObj = JSON.parse(localStorage.getItem("subpathObj"));
        if (subpathObj && subpathObj.length > 0) {
          let filterSubObj = subpathObj.filter(
            (x) => x.id === parseInt(path) && x.type === subpathType,
          );
          if (
            filterSubObj.length > 0 &&
            filterSubObj[0]?.additionalData &&
            (filterSubObj[0]?.additionalData.location ||
              filterSubObj[0]?.additionalData.jobLocation)
          ) {
            let subpath = {
              id: filterSubObj[0].id,
              name: filterSubObj[0].name,
              icon: "",
              type: subpathType,
              url: subpathUrl + filterSubObj[0].id,
              additionalData: filterSubObj[0].additionalData,
            };
            dataArray.push(subpath);
            setSubPathName(subpath.name);
          } else {
            let response = await getSubpathFromService(
              BreadCrumbType,
              path,
              subpathType,
            );
            if (response) {
              response["url"] = subpathUrl + response.id;
              dataArray.push(response);
              setSubPathName(response.name);
            } else {
              navigate("/layout/404");
              return [];
            }
          }
        } else {
          let response = await getSubpathFromService(
            BreadCrumbType,
            path,
            subpathType,
          );
          if (response) {
            response["url"] = subpathUrl + response.id;
            dataArray.push(response);
            setSubPathName(response.name);
          } else {
            authService
              .logout()
              .catch((err) => console.error("Logout error:", err));
            dispatch(clearAuth());
            dispatch(updateNextPath("null"));
            // navigate('/ats/login');
            dispatch(resetStore());
            await persistor.flush();
            await persistor.purge();
            localStorage.clear();
            sessionStorage.clear();
            Cookies.remove("userName");
            Cookies.remove("userPassword");
            Cookies.remove("AccessToken");
            return [];
          }
        }
      }
      let ArryObj = JSON.parse(JSON.stringify(filteredData[0]));
      ArryObj.url = undefined;
      dataArray.push(ArryObj);
      return dataArray;
    }
  };

  const getSubpathFromService = async (moduleType, path, subpathType) => {
    if (moduleType === "jobpostings") {
      const jobpostingResponse = await Jobpostingsbyid(path);
      if (jobpostingResponse.data.code === 200) {
        let postingBreadCrumb = `${jobpostingResponse.data.data[0].jobTitle} (${jobpostingResponse.data.data[0].jobCode})`;
        let jobDetails = JSON.parse(
          jobpostingResponse.data.data[0]?.customFields,
        );
        let additionInfoObj = jobDetails
          ?.map((field, index) => ({
            id: index + 1,
            key: field.key,
            value: field.value,
          }))
          .filter((item) => item.value && item.value !== "");
        let additionalData = {
          jobStatus: jobpostingResponse.data.data[0]?.jobStatus || "",
          lastUpdated:
            GetTimeZone(jobpostingResponse.data.data[0]?.updatedAt) || "",
          jobType:
            jobpostingResponse.data.data[0]?.jobType.replace(/,/g, ", ") || "",
          workModel: jobpostingResponse.data.data[0]?.workModel || "",
          jobLocation: jobpostingResponse.data.data[0].location || "",
          experience:
            additionInfoObj?.filter((x) => x.key === "Experience")[0]?.value ||
            "",
          segment: jobpostingResponse.data.data[0]?.segmentId || "",
          priority: jobpostingResponse.data.data[0]?.priority || "",
        };
        let subpath = {
          id: jobpostingResponse.data.data[0].id,
          name: postingBreadCrumb,
          icon: "",
          type: subpathType,
          additionalData: additionalData,
        };
        setBreadCrumb(
          jobpostingResponse.data.data[0].id,
          postingBreadCrumb,
          subpathType,
          additionalData,
        );
        return subpath;
      }
    } else if (moduleType === "applicants") {
      const applicantResponse = await ApplicantsById(path);
      if (applicantResponse.data.code === 200) {
        let myData = applicantResponse?.data?.data[0];
        let workExpObj = JSON.parse(myData?.workExp) || [];
        let designation =
          workExpObj?.length > 0
            ? `${workExpObj[0]?.jobTitle || workExpObj[0]?.title || ""}${workExpObj[0]?.organization ? " / " + workExpObj[0]?.organization : ""}`
            : "";
        let expObject = workExpObj[0]?.experienceInMonths
          ? workExpObj[0]?.experienceInMonths
          : {
            startDate: workExpObj[0]?.startDate,
            endDate: Boolean(workExpObj[0]?.isCurrent)
              ? "present"
              : workExpObj[0]?.endDate,
          };
        let additionalData = {
          applicantName: myData?.firstName + " " + myData?.lastName,
          currentWorking: {
            designation: designation,
            from: getWorkonDate(expObject, "level2"),
          },
          emailId: myData?.emailId,
          contactNumber: myData?.contactNumber,
          alternateContactNumber: myData?.alternateContactNumber,
          linkedIn: myData?.linkedIn ?? "",
          location:
            myData?.formattedLocation?.trim() ||
            [
              myData?.locationCity,
              myData?.locationState,
              myData?.locationCountry,
            ]
              .filter(Boolean)
              .join(", ") || "",
        };
        let subpath = {
          id: myData?.id,
          name: myData?.fullName,
          icon: "",
          type: subpathType,
          additionalData: additionalData,
        };
        setBreadCrumb(
          myData?.id,
          myData?.fullName,
          subpathType,
          additionalData,
        );
        return subpath;
      }
    } else if (moduleType === "clients") {
      const clientsResponse = await GetClients(path);
      if (clientsResponse.data.code === 200) {
        let clientData = clientsResponse.data.clientdashboard?.client;
        let additionalData = {
          status: clientData.status,
          createdAt: moment(clientData.createdDate)
            .local()
            .format("DD MMM, YYYY"),
        };
        let subpath = {
          id: clientData.id ? clientData.id : "",
          name: clientData.clientName ? clientData.clientName : "",
          icon: "",
          type: subpathType,
          additionalData: additionalData,
        };
        setBreadCrumb(
          clientData.id ? clientData.id : "",
          clientData.clientName ? clientData.clientName : "",
          subpathType,
          additionalData,
        );
        return subpath;
      }
    } else if (moduleType === "projects") {
      const projectsResponse = await GetProjectById(path);
      if (projectsResponse?.data?.code === 200) {
        let subpath = {
          id: projectsResponse.data.data[0].id
            ? projectsResponse.data.data[0].id
            : "",
          name: projectsResponse.data.data[0].name
            ? projectsResponse.data.data[0].name
            : "",
          icon: "",
          type: subpathType,
        };
        setBreadCrumb(
          projectsResponse.data.data[0].id
            ? projectsResponse.data.data[0].id
            : "",
          projectsResponse.data.data[0].name
            ? projectsResponse.data.data[0].name
            : "",
          subpathType,
        );
        return subpath;
      }
    }
  };

  const AssociatedMenuChangeHandler = () => {
    const url = window.location.pathname;
    const path = url.substring(url.lastIndexOf("/") + 1);
    const isAssociatedJobs = url.includes("associatedjobs");
    const isAssociatedApplicants = url.includes("associatedapplicants");
    if (
      path !== "landing" &&
      path !== "dashboard" &&
      path !== "create" &&
      isAssociatedApplicants
    ) {
      setMenuType("applicants");
      setMenuData(applicantsMenus);
    } else if (
      path !== "landing" &&
      path !== "dashboard" &&
      path !== "create" &&
      isAssociatedJobs
    ) {
      setMenuType("jobpostings");
      setMenuData(jobPostingMenus);
    }
    setIsAssociated(sessionStorage.getItem("AssociatedId"));
  };

  useEffect(() => {
    const storageEventHandler = (event) => {
      const changeMenu = event.currentTarget.localStorage.AssociatedMenu;
      if (changeMenu && changeMenu !== "false") {
        AssociatedMenuChangeHandler();
      } else {
        if (jobPostingMenus.length > 0) {
          MenuChangeHandler();
        }
      }
    };
    window.addEventListener("storage", storageEventHandler);
    return () => {
      window.removeEventListener("storage", storageEventHandler);
    };
    // eslint-disable-next-line
  }, [jobPostingMenus]);

  const onBreadCrumbHandler = (list) => {
    if (location.pathname === `/ats/layout/${list.url}`) {
      return
    }
    if (
      list.name === "Associated Applicants" ||
      list.name === "Associated Jobs"
    ) {
      let actualId = sessionStorage.getItem("actualId");
      if (actualId) {
        setIsAssociated(actualId);
        dispatch(updateNextPath("null"));
      }
    } else if (list.url !== undefined) {
      // dispatch(updateNextPath("null"));
      dispatch(resetSelectedJobPosting());
      if (list.name === "Job Postings") {
        // Already handled by the reset above
      } else if (list.name === "Jobs" && list.type === "clients") {
        // Already handled by the reset above
      }
      dispatch(toggleSidebar(false));
      sessionStorage.removeItem("AssociatedId");
      sessionStorage.removeItem("actualId");
      setIsAssociated("");
      setMenuType("");
      setMenuData(null);
      setBreadcrumbChild([]);
      navigate(list.url);
      if (list.url === "jobpostings/landing") {
        dispatch(jobpostingsbyidStartReducer());
      }
    } else if ((list.name === "Jobs" && list.type === "clients") || (list.name === "Jobs" && list.type === "projects")) {
      dispatch(updateNextPath("null"));
      dispatch(resetSelectedJobPosting());
      dispatch(toggleSidebar(false));
      navigate(location.pathname);
    }
  };

  const markInstance = useRef(null);
  const markInstanceContext = useRef(null);
  const observerRef = useRef(null);
  const isHighlightingRef = useRef(false);
  const pendingHighlightRef = useRef(false);

  // Move debounce outside or use useCallback
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  useEffect(() => {
    const isApplicantsPage = location.pathname.includes("applicants");

    if (!isApplicantsPage) {
      dispatch(resetHighlightFilter([]));
      dispatch(resetSelectedApplicant());
    }

    const context = document.querySelector("#content-area");

    if (!context) return;

    // Reuse Mark.js instance
    if (
      !markInstance.current ||
      markInstanceContext.current !== context
    ) {
      markInstance.current = new Mark(context);
      markInstanceContext.current = context;
    }

    const observerConfig = {
      childList: true,
      subtree: true,
      characterData: true,
    };

    const buildKeywords = () => {
      const allKeywords = [];
      let searchTarget = advSearchObj || {};

      if (searchTarget?.advSearch) {
        searchTarget = searchTarget.advSearch;
      } else if (searchTarget?.params) {
        searchTarget = searchTarget.params;
      }

      Object.entries(searchTarget).forEach(([key, value]) => {
        // Skip unwanted fields
        if (
          [
            "recruiterId",
            "yearsExperienceMax",
            "yearsExperienceMin",
            "locationId",
            "radius",
          ].includes(key)
        ) {
          return;
        }

        if (!value) return;
        // Handle arrays
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (key === "custom" && item?.value) {
              allKeywords.push(String(item.value).trim());
            } else if (
              key === "Candidatestatus" &&
              item?.internal
            ) {
              allKeywords.push(String(item.internal).trim());
            } else if (item) {
              allKeywords.push(String(item).trim());
            }
          });
          return;
        }

        // Handle comma-separated strings
        if (typeof value === "string") {
          value
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean)
            .forEach((item) => allKeywords.push(item));

          return;
        }

        // Primitive fallback
        const strValue = String(value).trim();
        if (strValue) {
          allKeywords.push(strValue);
        }
      });
      // Remove duplicates + empty strings
      return [...new Set(allKeywords.filter(Boolean))];
    };

    const reconnectObserver = () => {
      if (!observerRef.current) return;
      observerRef.current.disconnect();
      observerRef.current.observe(context, observerConfig);
    };

    const applyHighlight = () => {
      // Queue pending execution
      if (isHighlightingRef.current) {
        pendingHighlightRef.current = true;
        return;
      }

      try {
        if (!context || !markInstance.current) return;
        const allKeywords = buildKeywords();
        isHighlightingRef.current = true;
        pendingHighlightRef.current = false;
        observerRef.current?.disconnect();

        const finishHighlighting = () => {
          isHighlightingRef.current = false;
          reconnectObserver();
          if (pendingHighlightRef.current) {
            pendingHighlightRef.current = false;
            applyHighlight();
          }
        };

        // No keywords -> remove highlights only
        if (!allKeywords.length) {
          markInstance.current.unmark({
            done: finishHighlighting,
          });
          return;
        }

        // Remove old highlights then apply new
        markInstance.current.unmark({
          done: () => {
            markInstance.current?.mark(allKeywords, {
              separateWordSearch: false,
              exclude: [
                ".detail-card-empty",
                ".detail-card-empty *",
                "#total-record-count-text",
                "#total-record-count-text *",
                "#Applicant-tabs",
                "#Applicant-tabs *",
              ],
              done: finishHighlighting,
            });
          },
        });
      } catch (error) {
        isHighlightingRef.current = false;
        reconnectObserver();
        console.error("Highlighting failed:", error);
      }
    };
    // Initial highlight
    applyHighlight();
    // Debounced observer callback
    const debouncedApplyHighlight = debounce(
      applyHighlight,
      300
    );
    observerRef.current = new MutationObserver(() => {
      debouncedApplyHighlight();
    });
    observerRef.current.observe(context, observerConfig);
    return () => {
      observerRef.current?.disconnect();
      observerRef.current = null;
      isHighlightingRef.current = false;
      pendingHighlightRef.current = false;
      markInstance.current?.unmark();
    };
  }, [location.pathname, advSearchObj, outletRefreshKey]);

  return (
    <>
      <Header
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
      />
      {showMessage !== "" ? (
        <MessageBar message={showMessage} type={showMsgType} />
      ) : (
        ""
      )}
      {(showLoader.value || showUncommonLoader) &&
        showLoader.isGlobalLoading ? (
        <Loader />
      ) : (
        ""
      )}
      <div
        id={menuData !== null ? "subLayout" : "mainLayout"}
        className={isSidebarHidden ? "full-width-layout" : ""}
      >
        <div
          style={{
            width: "100%",
            display: menuData !== null && !isSidebarHidden ? "" : "none",
          }}
        >
          {menuData !== null &&
            (menuType !== "helpsection" ? breadcrumbChild?.length > 0 : true) ? (
            <nav>
              <NavSidebar
                isAssociat={isAssociated}
                drawerWidth={drawerWidth}
                menuList={menuData}
                menuType={menuType}
                subPathName={subPathName}
                aditionalData={breadcrumbChild[1]?.additionalData}
              />
            </nav>
          ) : (
            ""
          )}
        </div>
        {location.pathname !== "/ats/layout" ? (
          <div
            style={{
              minWidth:
                menuData !== null && breadcrumbChild?.length > 0
                  ? isSidebarHidden
                    ? "100%"
                    : `calc(100% - ${drawerWidth}px)`
                  : "100%",
              margin: menuData !== null ? 0 : "0 auto",
              boxSizing: "border-box",
            }}
          >
            <div
              id="content-area"
              key={outletRefreshKey}
              style={{
                backgroundColor:
                  location.pathname.includes("landing") ||
                    location.pathname.includes("dashboard")
                    ? ""
                    : "#fff",
                padding:
                  location.pathname.includes("landing") ||
                    location.pathname.includes("dashboard")
                    ? ""
                    : `${isSidebarHidden ? "70px" : "100px"} 2% 50px`,
                maxHeight: menuData !== null ? "calc(100vh - 150px)" : "",
                minHeight: menuData !== null ? "calc(99.7vh - 149px)" : "auto",
                position: "relative",
                overflow: "auto",
                overflowX: "hidden",
              }}
            >
              {!islandingPage && breadcrumbChild?.length > 0 ? (
                <Breadcrumbs
                  className="breadCrumbs"
                  style={{ height: isSidebarHidden ? "80px" : "154px" }}
                >
                  <div>
                    {IconsComponent(
                      breadcrumbChild[breadcrumbChild.length - 1].icon,
                      themeSettings,
                    )}
                  </div>
                  {breadcrumbChild.length > 0 &&
                    breadcrumbChild.map((list, i) => (
                      <Typography
                        className={
                          list?.url === undefined && list?.type === ""
                            ? ""
                            : "breadCrumbpointer"
                        }
                        key={i}
                        color="text.primary"
                        onClick={() => {
                          onBreadCrumbHandler(list);
                        }}
                      >
                        {list?.type === "Job Code"
                          ? truncateWords(list?.name, 3, 25)
                          : list?.name}
                      </Typography>
                    ))}
                </Breadcrumbs>
              ) : (
                ""
              )}
              {selectedCountry && <Outlet />}
            </div>
            <Footercomp />
          </div>
        ) : (
          ""
        )}
        {location.pathname === "/ats/layout" ? (
          <div className="welcomeScreen">
            <img
              src={process.env.PUBLIC_URL + "/assests/welcomeScreen.svg"}
              alt="welcome screen"
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default Layout;
